<template>
  <div class="h-full overflow-y-scroll" v-loading="infoLoading">
    <div class="flex justify-start item-start mt-10px">
      <img src="../../../assets/images/titleIcon.png" alt="" />
      <span class="text-16px text-white custom-shadow ml-4px"> 基础信息 </span>
    </div>
    <div class="pl-16px border-2px p-10px rounded-5px border-[#45f2eb33] mt-10px">
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >项目名称：</span
        >
        <span class="truncate flex-1 text-14px mt-10px line-height-2.5">{{
          currentRelationData.projectName
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >主题：</span
        >
        <span class="truncate flex-1 text-14px line-height-2.5">{{
          currentRelationData.subject
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >类型：</span
        >
        <span class="truncate flex-1 text-14px line-height-2.5">{{
          currentRelationData.typeName
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >存在问题：</span
        >
        <span class="flex-1 text-14px line-clamp-box line-height-2.5">{{
          currentRelationData.description
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >整改责任人：</span
        >
        <span class="truncate flex-1 text-14px line-height-2.5">{{
          currentRelationData.rectificationUserName
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >整改期限：</span
        >
        <span class="truncate flex-1 text-14px line-height-2.5">{{
          currentRelationData.rectificationDeadline
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >整改措施：</span
        >
        <span class="flex-1 text-14px line-clamp-box line-height-2.5">{{
          currentRelationData.rectificationMeasure
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >物资/经费(万元)：</span
        >
        <span class="flex-1 text-14px line-clamp-box line-height-2.5">{{
          currentRelationData.budget
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >停工开始时间：</span
        >
        <span class="flex-1 text-14px line-clamp-box line-height-2.5">{{
          currentRelationData.lockOutStartDate
        }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
          >停工结束时间：</span
        >
        <span class="flex-1 text-14px line-clamp-box line-height-2.5">{{
          currentRelationData.lockOutEndDate
        }}</span>
      </div>
    </div>
    <div class="flex justify-start item-start mb-10px mt-25px">
      <img src="../../../assets/images/titleIcon.png" alt="" />
      <span class="text-16px text-white custom-shadow ml-4px"> 整改情况 </span>
    </div>
    <el-collapse accordion v-model="activeCollapse">
      <el-collapse-item
        v-for="item in currentRelationData.remarks"
        :key="item.remarkId"
        :title="item.rectificationDate"
        :name="item.remarkId"
      >
        <div class="pl-16px border-2px p-10px rounded-5px border-[#45f2eb33]">
          <div class="w-full flex text-white">
            <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
              >完成情况描述：</span
            >
            <span class="flex-1 text-14px line-clamp-box line-height-2.5">{{
              item.description
            }}</span>
          </div>
          <div class="w-full flex text-white">
            <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
              >整改人：</span
            >
            <span class="truncate flex-1 text-14px line-height-2.5">{{
              item.rectificationUserName
            }}</span>
          </div>
          <div class="w-full flex text-white">
            <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
              >整改后图片：</span
            >
            <div class="flex items-center flex-1">
              <el-image
                v-if="item.filePathStr"
                :src="item.filePathStr"
                class="w-28px h-28px cursor-pointer"
                fit="contain"
                :preview-src-list="[item.filePathStr]"
              >
                <div slot="error" class="image-slot text-12px text-[#aaa]">
                  <i class="el-icon-picture-outline text-32px"></i>
                </div>
              </el-image>
              <span v-else class="text-14px text-[#aaa]">暂无图片</span>
            </div>
          </div>
          <div class="w-full flex text-white">
            <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
              >验收人：</span
            >
            <span class="truncate flex-1 text-14px line-height-2.5">{{ item.acceptorName }}</span>
          </div>
          <div class="w-full flex text-white">
            <span class="truncate text-right w-120px text-14px text-[#aaa] line-height-2.5"
              >验收意见：</span
            >
            <span class="flex-1 text-14px line-clamp-box line-height-2.5">{{
              item.acceptanceOpinion
            }}</span>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import cardTitle from '@/components/cockpit/CardTitle'
import { SafetyQualityApi } from '@wiz-api/haiguang'

const safetyQualityApi = new SafetyQualityApi()
export default {
  components: {
    cardTitle,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {
          problemId: '',
        }
      },
    },
  },
  watch: {
    transferProps(newValue) {
      if (newValue) {
        this.getQualityInfo()
      }
    },
  },
  data() {
    return {
      // 质量问题详情
      currentRelationData: {
        style: '',
        desc: '',
        creator: '',
        createTime: '',
        status: 1,
      },
      infoLoading: false, // 详情加载loading
      activeCollapse: '', // 整改情况当前激活项
    }
  },
  methods: {
    /**
     * @description 获取质量问题详情
     */
    async getQualityInfo() {
      this.infoLoading = true
      const [err, res] = await safetyQualityApi.getSafetyQualityVisualProblemDetail({
        problemId: this.transferProps.problemId,
      })
      this.infoLoading = false
      if (!err) {
        this.currentRelationData = res
        if (this.currentRelationData?.remarks?.length) {
          this.activeCollapse = this.currentRelationData.remarks[0].remarkId
        }
      }
    },
  },
  created() {
    this.getQualityInfo()
  },
}
</script>

<style>
.btn-example {
  background: var(--cockpitTableHeaderTrBg) !important;
  background-blend-mode: var(--cockpitTableHeaderTrBgBlendMode);
  color: white !important;
}
.component-container {
  background-image: var(--containerBgImg);
  background-size: 100% 100%;
  padding: var(--containerPadding);
}
</style>

<style lang="scss" scoped>
.line-clamp-box {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.line-height-2\.5 {
  line-height: 2.5;
}

::v-deep .el-collapse-item__content{
  padding-right: 10px !important;
  padding-left: 0px !important;
}
</style>
